import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getDate,textDott } from "../../../helpers/TimeDate";
import { FetchTransaction } from "../../../redux/actions/PlanAction";
import Transaction from "../components/Transaction"
import Loder from "../../loder";
function TransactionModal(props) {
  const dispatch = useDispatch();
  const transactions = useSelector((state) => state.PlanReducer.transactions);
  console.log(transactions)

  useEffect(() => {
    dispatch(FetchTransaction());
  }, []);

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // className="trans "
      >
        <Modal.Body className="profile_modal_content">
          <Transaction/>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default TransactionModal;
